import React from "react";
import type { BayHireEntryState } from "@features/bay-hire/hooks/useBayHireEntryState";
import { useTranslation } from "react-i18next";

interface BayHireEntryStateMessageProps {
  entryState: Exclude<BayHireEntryState, "allowed">;
}

const BayHireEntryStateMessage: React.FC<BayHireEntryStateMessageProps> = ({ entryState }) => {
  const { t } = useTranslation();

  if (entryState === "denied") {
    return (
      <section
        aria-label="Denied Bay Hire entry"
        aria-live="polite"
        className="border border-amber-300 bg-amber-50 rounded-md p-4"
        data-testid="bay-hire-entry-denied"
      >
        <h2 className="text-lg font-semibold">
          {t("bay-hire.access-denied-title", {
            defaultValue: "Bay Hire request access denied",
          })}
        </h2>
        <p className="mt-1 text-sm text-gray-700">
          {t("bay-hire.access-denied-description", {
            defaultValue: "Your account does not have permission to request Bay Hire.",
          })}
        </p>
      </section>
    );
  }

  return (
    <section
      aria-label="Unavailable Bay Hire entry"
      aria-live="polite"
      className="border border-red-300 bg-red-50 rounded-md p-4"
      data-testid="bay-hire-entry-unavailable"
    >
      <h2 className="text-lg font-semibold">
        {t("bay-hire.company-context-required-title", {
          defaultValue: "Company context required",
        })}
      </h2>
      <p className="mt-1 text-sm text-gray-700">
        {t("bay-hire.company-context-required-description", {
          defaultValue:
            "Your company-scoped Bay Hire access cannot be evaluated because company details are missing or unavailable.",
        })}
      </p>
    </section>
  );
};

export default BayHireEntryStateMessage;
